import { Pipe, PipeTransform } from '@angular/core';
import { prettyPrintHours } from '../utilities/prettyPrintMinutes';

@Pipe({
  name: 'prettyPrintHours',
})
export class PrettyPrintHoursPipe implements PipeTransform {
  public transform(minutes: number): string {
    return prettyPrintHours(minutes);
  }
}
